module.exports = __webpack_public_path__ + "static/media/details-1-image-7.40aa683c.jpg";